module.exports = __webpack_public_path__ + "img/fig14.e92b05c0.jpg";